@if (showMarketHelp) {
    <ms-market-help [optionGroup]="optionGroup" [eventHelpText]="eventHelpText" />
}
<div class="ogp-market-help">
    @if (displayMultiSelectionText) {
        <ms-market-help [optionGroup]="optionGroup" [eventHelpText]="multiSelectionHelpText" />
    }
</div>
<ms-bet-builder-standard-option-group
    [event]="event"
    [tracking]="tracking"
    [trackingModuleType]="trackingModuleType"
    [sourceOfPick]="sourceOfPick"
    [optionGroup]="optionGroup" />
